import Layout from 'layouts/Layout'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Box, Paper } from '@mui/material'
import CaseCard from './CaseCard'
import DisbursementView from './Disbursement'
import RepaymentView from './Repayment'
import { Case } from 'api'
import './case.scss'
import Interest from './Interest'
import userRole from 'api/userRole'



export default function CaseView() {

    const [data, setData] = useState(null)
    const { id } = useParams()
    const role = userRole()

    const getData = async () => {
        try {
            const res = await Case.getById({ id })
            setData(res)
        } catch (error) {
            alert(error.message)
        }
    }

    useEffect(() => {
        getData()
    }, [])

    const case_info = data?.case_info || {}

    return (
        <Layout active={"ViewCase"} title={"View Case"}>
            <Box padding={1}>
                <Paper elevation={3}>
                    <CaseCard {...case_info} />
                </Paper>
                <br />
                <DisbursementView />
                <br />
                <RepaymentView />
                <br />
                {role == "approver" && <Interest />}
            </Box>
        </Layout>
    )
}
